import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { fromUploadedFileTypesAction } from '../actions';
import { IUploadedFileTypesResponse } from '../models/uploaded-file-types.model';

export const uploadedFileTypeFeatureKey = 'uploadedFileType';

export interface StaticDataUploadedFileTypeState {
  loadStaticDataUploadedFileType: void;
  loadStaticDataUploadedFileTypeResponse: IUploadedFileTypesResponse[];
  loadStaticDataUploadedFileTypeFailure: IGenericError<ErrorResponse>;
}

export const initialState: StaticDataUploadedFileTypeState = {
  loadStaticDataUploadedFileType: undefined,
  loadStaticDataUploadedFileTypeResponse: undefined,
  loadStaticDataUploadedFileTypeFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromUploadedFileTypesAction.loadUploadedFileTypes, (state, action) => ({
    ...state,
    loadStaticDataUploadedFileType: null
  })),

  on(fromUploadedFileTypesAction.loadUploadedFileTypesSuccess, (state, action) => ({
    ...state,
    loadStaticDataUploadedFileTypeResponse: action.response
  })),

  on(fromUploadedFileTypesAction.loadUploadedFileTypesFailure, (state, action) => ({
    ...state,
    loadStaticDataUploadedFileTypeFailure: action.error
  }))
);

export const getStaticDataUploadedFileTypeResponse = (state: StaticDataUploadedFileTypeState) =>
  state.loadStaticDataUploadedFileTypeResponse;
export const getStaticDataUploadedFileTypeFailure = (state: StaticDataUploadedFileTypeState) => state.loadStaticDataUploadedFileTypeFailure;
